import * as React from 'react';
import Typography from '@mui/material/Typography';

export default function TypographyDetail({ type, text }) {
  return (
    <>
      <Typography style={{ fontWeight: "bolder", textTransform: "uppercase", fontSize: "18px" }} gutterBottom>
        {type}
      </Typography>
      <Typography sx={{ whiteSpace: 'pre-line' }}>
        {text}
      </Typography>
    </>
  );
}
